import { createFileRoute } from "@tanstack/react-router"
import BuyCapacityTab from "~/components/noos-supply-plan/buy-detail/BuyCapacityTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/capacity",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("NOOS Supply Plan - Buy Detail - Capacity")
  return <BuyCapacityTab />
}
